import { useState, useEffect } from "react";
import "./Header.css";
import { Icon } from "@iconify/react";
import punchInImg from "../../Assets/Images/image.png";
import punchBackImg from "../../Assets/Images/punch-back-img.png";
import ConfirmationModal from "../Model/ConfirmationModal";
import { reverseGeocode } from "../../Utils/geocode";
import punchBackImg1 from "../../Assets/Images/Mask group.png";

const Header = ({ onNewEntry }) => {
  const punchInIcon = punchInImg;
  const [loginLocation, setLoginLocation] = useState("");
  const [logoutLocation, setLogoutLocation] = useState("");
  const [isPunchedIn, setIsPunchedIn] = useState(false);
  const [punchInTime, setPunchInTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState("00:00:00");
  const [showPrompt, setShowPrompt] = useState(false); // State for punchout confirmation
  const [showPromptPunchIn, setShowPromptPunchIn] = useState(false); // State for punchout confirmation
  // const [punchSuccess, setPunchSuccess] = useState(false);
  const [punchSuccess, setPunchSuccess] = useState(false);
  const [punchOutSuccess, setPunchOutSuccess] = useState(false);
  const [punchInLoading, setPunchInLoading] = useState(false);
  const [punchOutLoading, setPunchOutLoading] = useState(false);

  const [punchError, setPunchError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [reportKey, setReportKey] = useState(0);
  const [date, setDate] = useState("");
  // Helper function to parse latitude and longitude from string
  const parseLatLongString = (str) => {
    if (!str) return null;
    const latMatch = str.match(/Lat:\s*(-?\d+(\.\d+)?)/i);
    const lonMatch = str.match(/Long:\s*(-?\d+(\.\d+)?)/i);
    if (latMatch && lonMatch) {
      return {
        lat: parseFloat(latMatch[1]),
        lon: parseFloat(lonMatch[1]),
      };
    }
    return null;
  };

  useEffect(() => {
    const fetchLoginDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/my/login-details`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          },
        );

        if (response.ok) {
          const data = await response.json();
          console.log("data login details", data);

          if (data && data.checkInTime && data.checkOutTime === null) {
            console.log("went in punched in block");
            console.log("checkInTime from API:", data.checkInTime);

            // Parse the checkInTime format "25-09-2025 11:16::46"
            let loginTime;

            if (data.checkInTime && data.checkInTime.includes(" ")) {
              // Handle full datetime format "25-09-2025 11:16::46"
              const [datePart, timePart] = data.checkInTime.split(" ");

              // Parse date part "25-09-2025" (DD-MM-YYYY)
              const [day, month, year] = datePart.split("-").map(Number);

              // Parse time part "11:16::46" and handle double colons
              const timeStr = timePart.replace("::", ":");
              const [hour, minute, second] = timeStr.split(":").map(Number);

              // Create date object (note: month is 0-indexed in JavaScript Date)
              loginTime = new Date(year, month - 1, day, hour, minute, second);
            } else if (data.checkInTime) {
              // Handle time-only format "11:16:46" or "11:16::46"
              const timeStr = data.checkInTime.replace("::", ":");
              const [hour, minute, second] = timeStr.split(":").map(Number);
              const today = new Date(data.date || new Date());
              loginTime = new Date(today);
              loginTime.setHours(hour);
              loginTime.setMinutes(minute);
              loginTime.setSeconds(second);
            } else {
              // Fallback to current date
              loginTime = new Date();
            }

            console.log("Parsed loginTime:", loginTime);
            const timestamp = loginTime.getTime();
            setPunchInTime(timestamp);
            setIsPunchedIn(true);
            localStorage.setItem("punchInTime", timestamp.toString());
            localStorage.setItem("isPunchedIn", "true");
            // Fetch and set login location if available
            if (data.checkInLocation) {
              const coords = parseLatLongString(data.checkInLocation);
              if (coords) {
                const locationName = await reverseGeocode(
                  coords.lat,
                  coords.lon,
                );
                setLoginLocation(locationName);
                localStorage.setItem("loginLocation", locationName);
              }
            }
          } else {
            console.log("did not go in punched in block");

            // Already punched out or no data for today
            setIsPunchedIn(false);
            setPunchInTime(null);
            localStorage.removeItem("punchInTime");
            localStorage.removeItem("isPunchedIn");
          }
        } else {
          // ❗ Handle when user hasn't punched in today
          const errorData = await response.json();
          const knownMessage =
            errorData?.message?.includes("punched in for today") ||
            errorData?.message?.includes("not found");

          if (response.status === 404 || knownMessage) {
            setIsPunchedIn(false);
            setPunchInTime(null);
            localStorage.removeItem("punchInTime");
            localStorage.removeItem("isPunchedIn");
          } else {
            console.error(
              "Unexpected error fetching login details:",
              errorData?.message,
            );
          }
        }
      } catch (err) {
        console.error("Login details fetch failed:", err);
        setIsPunchedIn(false);
        setPunchInTime(null);
        localStorage.removeItem("punchInTime");
        localStorage.removeItem("isPunchedIn");
      }
    };

    fetchLoginDetails();
  }, []);

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);
    setDate(formattedDate);
  }, []);

  const [shiftProgress, setShiftProgress] = useState(0);

  const SHIFT_DURATION_HOURS = 8;
  const SHIFT_DURATION_SECONDS = SHIFT_DURATION_HOURS * 3600;

  useEffect(() => {
    let timer;
    if (isPunchedIn && punchInTime) {
      timer = setInterval(() => {
        const punchIn =
          typeof punchInTime === "number"
            ? punchInTime
            : new Date(punchInTime).getTime();
        const secondsElapsed = Math.floor((Date.now() - punchIn) / 1000);
        setElapsedTime(formatTime(secondsElapsed));

        // Calculate progress percentage
        const progress = Math.min(
          (secondsElapsed / SHIFT_DURATION_SECONDS) * 100,
          100,
        );
        setShiftProgress(progress);
      }, 1000);
    } else {
      setElapsedTime("00:00:00");
      setShiftProgress(0);
    }

    return () => clearInterval(timer);
  }, [isPunchedIn, punchInTime]);

  // Inside useEffect where elapsed time is updated
  // useEffect(() => {
  //   let timer;
  //   if (isPunchedIn && punchInTime) {
  //     timer = setInterval(() => {
  //       const punchIn =
  //         typeof punchInTime === "number"
  //           ? punchInTime
  //           : new Date(punchInTime).getTime();
  //       const secondsElapsed = Math.floor((Date.now() - punchIn) / 1000);

  //       setElapsedTime(formatTime(secondsElapsed));

  //       // Calculate progress percentage
  //       const progress = Math.min(
  //         (secondsElapsed / SHIFT_DURATION_SECONDS) * 100,
  //         100
  //       );
  //       setShiftProgress(progress);
  //     }, 1000);
  //   } else {
  //     setElapsedTime("00:00:00");
  //     setShiftProgress(0);
  //   }

  //   return () => clearInterval(timer);
  // }, [isPunchedIn, punchInTime]);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const weekday = date.toLocaleString("en-US", { weekday: "short" });
    return `${weekday}, ${day} ${month} ${year}`;
  };

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude });
        },
        (error) => {
          console.error("Geolocation error:", error);
          reject("Location not available");
        },
      );
    });
  };

  const confirmPunchIn = async () => {
    console.log("========== Punch Started");
    setPunchInLoading(true); // 👈 Start spinner

    try {
      const { latitude, longitude } = await getCurrentLocation();
      if (isPunchedIn) {
        setErrorMessage("You’ve already punched in today.");
        setPunchError(true);
        setTimeout(() => setPunchError(false), 5000);
        return;
      }
      if (!latitude || !longitude) {
        throw new Error("Location data missing");
      }

      const location = `Lat: ${latitude}, Long: ${longitude}`;
      console.log("Location of punch in", location);
      const encodedLocation = encodeURIComponent(location);

      const locationName = await reverseGeocode(latitude, longitude);

      const response = await fetch(
        // `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/punch-in?loginLocation=${encodedLocation}`,
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets?loginLocation=${encodedLocation}`,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.ok) {
        setShowPromptPunchIn(false);
        setLoginLocation(locationName);
        console.log("loginLocation", locationName);
        setPunchSuccess(true);
        setIsPunchedIn(true);
        onNewEntry({ refresh: true });
        const currentTime = Date.now();
        setPunchInTime(currentTime);
        localStorage.setItem("punchInTime", currentTime.toString());
        localStorage.setItem("isPunchedIn", "true");
        localStorage.setItem("loginLocation", locationName);

        setErrorMessage("Punch In successful");
        setTimeout(() => setPunchSuccess(false), 5000);
        setReportKey((prevKey) => prevKey + 1);
      } else {
        const errorRes = await response.json();
        console.error("Backend error:", errorRes);
        setPunchError(true);
        setErrorMessage(errorRes?.error || "Error during Punch In");
        setTimeout(() => setPunchError(false), 5000);
      }
    } catch (error) {
      console.error("Punch In failed:", error);
      setPunchError(true);
      setErrorMessage(error.message || "Punch In failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    } finally {
      setPunchInLoading(false); // 👈 Stop spinner
    }
  };
  const cancelPunchOut = () => {
    setShowPrompt(false);
    setShowPromptPunchIn(false);
  };

  // useEffect(() => {
  //   const storedPunchTime = localStorage.getItem("punchInTime");
  //   if (storedPunchTime) {
  //     setIsPunchedIn(true);
  //     setPunchInTime(Number(storedPunchTime));
  //   }
  // }, []);
  useEffect(() => {
    const storedPunchTime = localStorage.getItem("punchInTime");
    const storedPunchState = localStorage.getItem("isPunchedIn") === "true";
    const loginLoc = localStorage.getItem("loginLocation") || "";
    const logoutLoc = localStorage.getItem("logoutLocation") || "";

    if (storedPunchTime && storedPunchState) {
      setPunchInTime(Number(storedPunchTime));
      setIsPunchedIn(true);
      setLoginLocation(loginLoc);
    }

    setLogoutLocation(logoutLoc);
  }, []);
  useEffect(() => {
    if (isPunchedIn && loginLocation) {
      console.log("✅ Already punched in from:", loginLocation);
    }
  }, [isPunchedIn, loginLocation]);

  const handlePunchIn = async () => {
    try {
      setShowPromptPunchIn(true);
    } catch (error) {
      console.error("Error punching In:", error);
      setPunchError(true);
      setErrorMessage("Punch In failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    }
  };

  const handlePunchOut = async () => {
    try {
      setShowPrompt(true);
    } catch (error) {
      console.error("Error punching out:", error);
      setPunchError(true);
      setErrorMessage("Punch Out failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    }
  };

  const confirmPunchOut = async () => {
    setPunchOutLoading(true); // 👈 Start spinner
    try {
      const { latitude, longitude } = await getCurrentLocation();
      const locationName = await reverseGeocode(latitude, longitude);
      const encodedLocation = encodeURIComponent(
        `Lat: ${latitude}, Long: ${longitude}`,
      );

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets?logoutLocation=${encodedLocation}`,
        {
          method: "PATCH",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.ok) {
        // setPunchSuccess(true);
        // setErrorMessage("Punch Out successful");
        // setTimeout(() => setPunchSuccess(false), 5000);
        setLogoutLocation(locationName); // ✅ Set for display
        localStorage.setItem("logoutLocation", locationName); // ✅ Save
        console.log("logoutLocation", locationName);
        setPunchOutSuccess(true);
        setTimeout(() => setPunchOutSuccess(false), 5000);

        setPunchSuccess(true);
        setErrorMessage("Punch Out successful");
        setTimeout(() => setPunchSuccess(false), 5000);
        const logoutTime = Date.now();
        const totalSeconds = Math.floor((logoutTime - punchInTime) / 1000);

        // Save attendance entry
        onNewEntry({
          date: new Date(punchInTime).toISOString().split("T")[0],
          loginTime: new Date(punchInTime).toLocaleTimeString(),
          loginLocation,
          // loginLocation: "Shivraj Nagar, Pune",
          logoutTime: new Date(logoutTime).toLocaleTimeString(),
          // logoutLocation: "Shivraj Nagar, Pune",
          logoutLocation: locationName,
          totalHours: formatTime(totalSeconds),
          tasks: "Edit Tasks",
          refresh: true,
        });

        // Reset state
        setIsPunchedIn(false);
        setPunchInTime(null);
        localStorage.removeItem("punchInTime");
        localStorage.removeItem("isPunchedIn");
        setShowPrompt(false);
        setReportKey((prevKey) => prevKey + 1);
      } else {
        const errorData = await response.json();
        const errorMsg =
          errorData?.error === "You have already punched out today."
            ? "You've already punched out today."
            : "Error during Punch Out";

        setPunchError(true);
        setErrorMessage(errorMsg);
        setTimeout(() => setPunchError(false), 5000);
      }
    } catch (error) {
      console.error("Error punching out:", error);
      setPunchError(true);
      setErrorMessage("Punch Out failed. Please try again.");
      setTimeout(() => setPunchError(false), 5000);
    } finally {
      setPunchOutLoading(false); // 👈 Stop spinner
    }
  };

  return (
    <div className="header-container">
      <div
        className={`header ${isPunchedIn ? "header-green" : ""}`}
        style={
          isPunchedIn
            ? {
                background: `linear-gradient(
            90deg,
            #37C579 ${shiftProgress}%,
            #ABABAB ${shiftProgress}%
          )`,
                transition: "background 1s linear",
                animationDuration: `${Math.max(1, 5 - shiftProgress / 20)}s`,
              }
            : {}
        }
      >
        {/* ✨ Shine only when punched in */}
        {isPunchedIn && (
          <div
            className="shine-overlay"
            style={{
              width: `${shiftProgress}%`, // only on green part
            }}
          ></div>
        )}
        <h2 className="date mt-2">Today, {new Date().toLocaleDateString()}</h2>

        {punchError && <div className="prompt-message">{errorMessage}</div>}

        {isPunchedIn && (
          <div>
            <p className="timer">{elapsedTime}</p>
            <div className="time-info">
              <p className="puch-in-time">
                {" "}
                <Icon
                  icon="formkit:time"
                  width="12"
                  height="12"
                  color="white"
                />
                Punch In Time:{" "}
                {punchInTime
                  ? new Date(punchInTime).toLocaleTimeString()
                  : "N/A"}
              </p>

              {/* <p className="location">
                {" "}
                <Icon
                  icon="fluent:location-28-regular"
                  width="12"
                  height="12"
                  color="white"
                />
                Shivrajnagar, pune
              </p> */}
              {loginLocation && (
                <p className="location">
                  <Icon
                    icon="fluent:location-28-regular"
                    width="12"
                    height="12"
                    color="white"
                  />
                  {loginLocation}
                </p>
              )}

              {/* <p className="task">
                {" "}
                <Icon
                  icon="material-symbols-light:add"
                  width="12"
                  height="12"
                  color="white"
                />
                Task
              </p> */}
            </div>
          </div>
        )}

        <div className="punch-container">
          {!isPunchedIn ? (
            <div className="punch-in-container">
              <button
                className="punch-btn punch-in"
                onClick={punchSuccess ? undefined : handlePunchIn}
                disabled={punchSuccess}
                title={punchSuccess ? "Already Punched In" : ""}
              >
                {punchInLoading ? (
                  <div
                    className="spinner-border text-light"
                    role="status"
                    style={{ width: "20px", height: "20px" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  <div className="wave-container">
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>

                    <img
                      src={punchInIcon}
                      alt="Punch In"
                      className="punch-icon mt-3"
                    />
                  </div>
                )}
              </button>
              <p className="punch-text mt-4">Punch In</p>
              <p className="greating">Wish you a Great Day!</p>
            </div>
          ) : (
            <button
              class="punchout-button"
              onClick={punchOutSuccess ? undefined : handlePunchOut}
              disabled={punchSuccess}
              title={punchSuccess ? "Already Punched Out" : ""}
            >
              {punchOutLoading ? (
                <div
                  className="spinner-border spinner-border-sm text-light"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <>
                  <span className="punchout-icon"></span> Punchout
                </>
              )}
            </button>
          )}
        </div>

        {/* Punchout Confirmation Prompt */}
        {/* {showPrompt && (
          <div className="prompt-overlay">
            <div className="prompt-box">
              <div className="d-flex justify-content-center align-item-center">
            <div className="Loading-icon">
 <Icon icon="et:hourglass" className="fs-4"  />
              </div>
              </div>
              <h3 className="prompt-title">Confirm Punch-Out</h3>
              <p>Are you sure you want to punch out?</p>
              <div className="prompt-actions">
                 <button onClick={cancelPunchOut} className="cancel-button">
                  Cancel
                </button>
                <button onClick={confirmPunchOut} className="confirm-button">
                  Punch Out
                </button>
               
              </div>
            </div>
          </div>
        )} */}
        <ConfirmationModal
          show={showPrompt}
          title="Confirm Punch-Out"
          message="Are you sure you want to punch out?"
          loadingMessage="Processing..." // ✅ now works
          icon="et:hourglass"
          confirmLabel="Punch Out"
          cancelLabel="Cancel"
          onConfirm={confirmPunchOut}
          onCancel={cancelPunchOut}
          loading={punchOutLoading} // 👈 pass loading prop
        />
        <ConfirmationModal
          show={showPromptPunchIn}
          title="Confirm Punch-In"
          message="Are you sure you want to punch In?"
          loadingMessage="Processing ..." // ✅ now works
          icon="et:hourglass"
          confirmLabel="Punch In"
          cancelLabel="Cancel"
          onConfirm={confirmPunchIn}
          onCancel={cancelPunchOut}
          loading={punchInLoading} // 👈 pass loading prop
        />
      </div>
    </div>
  );
};

export default Header;
